import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { CheckIcon } from 'components/icons';
import { ButtonsProps } from '../types';

export const SaveButton: FC<ButtonsProps> = (props) => {
  const { t } = useTranslation('translation');

  return (
    <Button type="text" icon={<CheckIcon fill="#A7B1C2" />} {...props}>
      {t('Save')}
    </Button>
  );
};
